import i18next from 'i18next';

/**
 * Loads the `push` i18n namespace (system-notification settings + invite card)
 * on demand. It is deliberately NOT in the static `resources` of ./index.js:
 * only the lazily-loaded NotificationSettingsSheet and PushInviteCard use it, so
 * the copy stays out of the main entry chunk. Both languages are added so a
 * language switch while the sheet is open still finds every key.
 *
 * Call it from the React.lazy factory, next to the component import:
 *   lazy(() => Promise.all([import('...'), loadPushNamespace()]).then(([m]) => m))
 *
 * Idempotent: the promise is cached; a failed import clears it so the next call
 * retries.
 */
let pending = null;

export function loadPushNamespace() {
  if (!pending) {
    pending = Promise.all([
      import('./locales/fr/push.json'),
      import('./locales/en/push.json'),
    ])
      .then(([fr, en]) => {
        i18next.addResourceBundle('fr', 'push', fr.default ?? fr, true, true);
        i18next.addResourceBundle('en', 'push', en.default ?? en, true, true);
      })
      .catch((error) => {
        pending = null;
        throw error;
      });
  }
  return pending;
}
